<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<style>
  :host {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 14px;
    color: #333;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 8px 0;
  }

  p {
    margin: 0;
  }

  .spacer {
    flex: 1;
  }

  .toolbar {
    height: 60px;
    margin: -8px;
    display: flex;
    align-items: center;
    background-color: rgb(255, 255, 255);
    color: #344960;
    font-weight: 600;
    border-bottom: 1px solid #eee;
  }

  .toolbar img {
    margin: 0 16px;
  }

  .toolbar #twitter-logo {
    height: 40px;
    margin: 0 16px;
  }

  .toolbar #twitter-logo:hover {
    opacity: 0.8;
  }

  .content {
    display: flex;
    margin: 32px auto;
    padding: 0 16px;
    max-width: 960px;
    flex-direction: column;
    align-items: center;
  }

  svg.material-icons {
    height: 24px;
    width: auto;
  }

  svg.material-icons:not(:last-child) {
    margin-right: 8px;
  }

  .card svg.material-icons path {
    fill: #888;
  }

  .card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 16px;
  }

  .card {
    border-radius: 4px;
    border: 1px solid #eee;
    background-color: #fafafa;
    height: 40px;
    width: 200px;
    margin: 0 8px 16px;
    padding: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    line-height: 24px;
  }

  .card-container .card:not(:last-child) {
    margin-right: 0;
  }

  .card.card-small {
    height: 10px;
    width: 168px;
  }

  .card-container .card:not(.highlight-card) {
    cursor: pointer;
  }

  .card-container .card:not(.highlight-card):hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 17px rgba(black, 0.35);
  }

  .card-container .card:not(.highlight-card):hover .material-icons path {
    fill: rgb(105, 103, 103);
  }

  .card.highlight-card {
    background-color: #344960;
    color: white;
    font-weight: 600;
    border: none;
    width: auto;
    min-width: 30%;
    position: relative;
  }

  svg#rocket {
    width: 80px;
    position: absolute;
    left: -10px;
    top: -24px;
  }

  svg#rocket-smoke {
    height: 100vh;
    position: absolute;
    top: 10px;
    right: 180px;
    z-index: -10;
  }

  a {
    color: #344960;
    text-decoration: none;
  }

  a:hover {
    color: #125699;
  }

  .terminal {
    position: relative;
    width: 80%;
    max-width: 600px;
    border-radius: 6px;
    padding-top: 45px;
    margin-top: 8px;
    overflow: hidden;
    background-color: rgb(15, 15, 16);
  }

  .terminal::before {
    content: "\2022 \2022 \2022";
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    background: rgb(58, 58, 58);
    color: #c2c3c4;
    width: 100%;
    font-size: 2rem;
    line-height: 0;
    padding: 14px 0;
    text-indent: 4px;
  }

  .terminal pre {
    font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
    color: white;
    padding: 0 1rem 1rem;
    margin: 0;
  }

  .circle-link {
    height: 40px;
    width: 40px;
    border-radius: 40px;
    margin: 8px;
    background-color: white;
    border: 1px solid #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: 1s ease-out;
  }

  .circle-link:hover {
    transform: translateY(-0.25rem);
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  }

  footer {
    margin-top: 8px;
    display: flex;
    align-items: center;
    line-height: 20px;
    justify-content: center;
  }

  footer a {
    display: flex;
    align-items: center;
  }

  .github-star-badge {
    color: #24292e;
    display: flex;
    align-items: center;
    font-size: 12px;
    padding: 3px 10px;
    border: 1px solid rgba(27, 31, 35, .2);
    border-radius: 3px;
    background-image: linear-gradient(-180deg, #fafbfc, #eff3f6 90%);
    margin-left: 4px;
    font-weight: 600;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  }

  .github-star-badge:hover {
    background-image: linear-gradient(-180deg, #f0f3f6, #e6ebf1 90%);
    border-color: rgba(27, 31, 35, .35);
    background-position: -.5em;
  }

  .github-star-badge .material-icons {
    height: 16px;
    width: 16px;
    margin-right: 4px;
  }

  svg#clouds {
    position: fixed;
    bottom: -160px;
    left: -230px;
    z-index: -10;
    width: 1920px;
  }


  /* Responsive Styles */
  @media screen and (max-width: 767px) {

    .card-container>*:not(.circle-link),
    .terminal {
      width: 100%;
    }

    .card:not(.highlight-card) {
      height: 16px;
      margin: 8px 0;
    }

    .card.highlight-card span {
      margin-left: 72px;
    }

    svg#rocket-smoke {
      right: 120px;
      transform: rotate(-5deg);
    }
    .like-content .chevron-icon,
    .like-content .main-link span,
    .like-content .like-content-text {
      display: none;
    }
  }

  @media screen and (max-width: 575px) {
    svg#rocket-smoke {
      display: none;
      visibility: hidden;
    }
  }

  .like-content {
    display: flex;
    padding-right: 40px;
  }
  .toolbar .like-content .main-link {
    display: flex;
  }
</style>

<!-- Toolbar -->
<div class="toolbar" role="banner">
  <img width="120" alt="IOMechs Logo" src="../assets/iomechs-logo.png" />
  <span>Angular Tags Input</span>
  <div class="spacer"></div>
  <div class="like-content">
    <span class="like-content-text">Like Angular Tag Input?&nbsp;</span>
    <a class="main-link" href="https://github.com/IOMechs/angular-tags-input" target="_blank" rel="noopener">
      <span>Give our repo a star.</span>
      <div class="github-star-badge">
        <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
        Star
      </div>
    </a>
    <a class="chevron-icon" href="https://github.com/IOMechs/angular-tags-input" target="_blank" rel="noopener">
      <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="#344960"/><path d="M0 0h24v24H0z" fill="none"/></svg>
    </a>
  </div>
</div>
<div class="content" role="main">
  <!-- Highlight Card -->
  <div class="card highlight-card card-small">
    <span>@iomechs/angular-tags-input</span>
  </div>
  <!-- Main -->
  <h1>Angular Tags Input</h1>
  <br>

  <form [formGroup]="simpleForm" class="main__form">
    <h5 class="main__form__heading">1. Input with subtypes and selected items are marked as tick</h5>
    <ti-angular-tags-input formControlName="nestedData" class="main__form__ti" [tagsData]="(sampleDataNested$ | async)"
    (tagAdded)="onTagAdded($event)" (valueChanged)="onValChanged($event)" [config]="nestedTagsInputConfig"
    [dropDownTemplate]="ddNestedTemplate">
  </ti-angular-tags-input>

    <input type="checkbox" name="hide-dd-on-blur" [checked]="nestedTagsInputConfig.hideDDOnBlur" (change)="changeNestedConfigOption($event, 'hideDDOnBlur')">
    <label for="hide-dd-on-blur">Hide dropdown on blur</label> &nbsp; &nbsp;

    <input type="checkbox" name="parent tag" [checked]="nestedTagsInputConfig.showParentTagsOnly" (change)="changeNestedConfigOption($event, 'showParentTagsOnly')">
    <label for="parent tag">Show parent tags only</label> &nbsp; &nbsp;

    <input type="checkbox" name="dd backdrop" [checked]="nestedTagsInputConfig.ddHasBackdrop" (change)="changeNestedConfigOption($event, 'ddHasBackdrop')">
    <label for="dd backdrop">Dropdown has backdrop</label> &nbsp; &nbsp;

    <input type="checkbox" name="hide-dd-on-select" [checked]="nestedTagsInputConfig.hideDDOnTagSelect" (change)="changeNestedConfigOption($event, 'hideDDOnTagSelect')">
    <label for="hide-dd-on-select">Hide dropdown on Tag selection</label> &nbsp; &nbsp;

    <h5>2. Custom nested component without showing tick on selected items.</h5>
		<ti-angular-tags-input formControlName="nestedData" class="main__form__ti" [tagsData]="(sampleDataNested$ | async)"
    (tagAdded)="onTagAdded($event)" (valueChanged)="onValChanged($event)" [config]="nestedTagsInputConfig1"
      [dropDownTemplate]="ddNestedTemplate">
    </ti-angular-tags-input>

    <h5 class="main__form__heading">3. Selected items will be hide from options list</h5>
    <ti-angular-tags-input formControlName="simpleData" class="main__form__ti" [tagsData]="(sampleDataSimple$ | async)"
      (tagAdded)="onTagAdded($event)" (valueChanged)="onValChanged($event)" [config]="simpleTagsInputConfig"
      [dropDownTemplate]="ddNestedTemplate" required="true">
    </ti-angular-tags-input>

    <h5 class="main__form__heading">4. Options to hide tick and items from list.</h5>
    <ti-angular-tags-input formControlName="simpleData" class="main__form__ti" [tagsData]="(sampleDataSimple$ | async)"
      (tagAdded)="onTagAdded($event)" (valueChanged)="onValChanged($event)" [config]="simpleTagsInputConfig2"
      [dropDownTemplate]="ddNestedTemplate" required="true">
    </ti-angular-tags-input>

    <input type="checkbox" name="tick mark" [checked]="simpleTagsInputConfig2.showTagsSelectedInDD" (change)="changeConfigOption($event, 'showTagsSelectedInDD')">
    <label for="tick mark">Hide tick</label> &nbsp; &nbsp;

    <input type="checkbox" name="show-tooltip-on-options" [checked]="simpleTagsInputConfig2.showTooltipOnOptions" (change)="changeConfigOption($event, 'showTooltipOnOptions')">
    <label for="show-tooltip-on-options">Show tooltip on Options</label> &nbsp; &nbsp;

    <input type="checkbox" name="render-tooltip-as-html" [checked]="simpleTagsInputConfig2.renderTooltipAsHtml" (change)="changeConfigOption($event, 'renderTooltipAsHtml')">
    <label for="render-tooltip-as-html">Render tooltip as HTML</label> &nbsp; &nbsp;

    <input type="checkbox" name="tags added" [checked]="simpleTagsInputConfig2.hideAddedTags" (change)="changeConfigOption($event, 'hideAddedTags')">
    <label for="tags added">Hide items</label> &nbsp; &nbsp;

    <input type="checkbox" name="hide tags" [checked]="simpleTagsInputConfig2.hideTags" (change)="changeConfigOption($event, 'hideTags')">
    <label for="hide tags">Hide tags</label> &nbsp; &nbsp;

    <input type="checkbox" name="selected item" [checked]="simpleTagsInputConfig2.toggleSelectionOnClick" (change)="changeConfigOption($event, 'toggleSelectionOnClick')">
    <label for="selected item">Remove on click selected item</label> &nbsp; &nbsp;

    <input type="checkbox" name="clear text" [checked]="simpleTagsInputConfig2.clearInputOnFocus" (change)="changeConfigOption($event, 'clearInputOnFocus')">
    <label for="clear text">Clear input text onfocus</label> &nbsp; &nbsp;

    <input type="checkbox" name="create tag" [checked]="simpleTagsInputConfig2.onlyFromAutoComplete" (change)="changeConfigOption($event, 'onlyFromAutoComplete')">
    <label for="create tag">Don't create tag on enter</label>

    <div class="main__form__error"
      *ngIf="simpleForm.get('simpleData').dirty && simpleForm.get('simpleData').hasError('required')">
      Value for simple data is required
    </div>

    <h5 class="main__form__heading">5. Options with image</h5>
    <ti-angular-tags-input formControlName="imageData" class="main__form__ti" [tagsData]="(sampleDataImage$ | async)"
      (tagAdded)="onTagAdded($event)" (valueChanged)="onValChanged($event)" [config]="imageTagsInputConfig"
      [dropDownTemplate]="imageDropdownTemplate">
    </ti-angular-tags-input>
  </form>
</div>
<ng-template #imageDropdownTemplate let-items="items" let-config="config" let-fns="fns">
  <div *ngIf="items.length" class="users-list">
    <tid-users-list-item *ngFor="let data of items" [item]="data" [config]="config" (itemClicked)="fns.onItemClicked($event)">
    </tid-users-list-item>
  </div>
</ng-template>
<!-- Footer -->
<footer>
  Love Angular Tags Input?&nbsp;
  <a href="https://github.com/angular/angular" target="_blank" rel="noopener"> Give our repo a star.
    <div class="github-star-badge">
      <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" /></svg>
      Star
    </div>
  </a>
  <a class="chevron-icon" href="https://github.com/IOMechs/angular-tags-input" target="_blank" rel="noopener">
    <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="#344960"/><path d="M0 0h24v24H0z" fill="none"/></svg>
  </a>
</footer>

<svg id="clouds" alt="Gray Clouds Background" xmlns="http://www.w3.org/2000/svg" width="2611.084" height="485.677"
  viewBox="0 0 2611.084 485.677">
  <path id="Path_39" data-name="Path 39"
    d="M2379.709,863.793c10-93-77-171-168-149-52-114-225-105-264,15-75,3-140,59-152,133-30,2.83-66.725,9.829-93.5,26.25-26.771-16.421-63.5-23.42-93.5-26.25-12-74-77-130-152-133-39-120-212-129-264-15-54.084-13.075-106.753,9.173-138.488,48.9-31.734-39.726-84.4-61.974-138.487-48.9-52-114-225-105-264,15a162.027,162.027,0,0,0-103.147,43.044c-30.633-45.365-87.1-72.091-145.206-58.044-52-114-225-105-264,15-75,3-140,59-152,133-53,5-127,23-130,83-2,42,35,72,70,86,49,20,106,18,157,5a165.625,165.625,0,0,0,120,0c47,94,178,113,251,33,61.112,8.015,113.854-5.72,150.492-29.764a165.62,165.62,0,0,0,110.861-3.236c47,94,178,113,251,33,31.385,4.116,60.563,2.495,86.487-3.311,25.924,5.806,55.1,7.427,86.488,3.311,73,80,204,61,251-33a165.625,165.625,0,0,0,120,0c51,13,108,15,157-5a147.188,147.188,0,0,0,33.5-18.694,147.217,147.217,0,0,0,33.5,18.694c49,20,106,18,157,5a165.625,165.625,0,0,0,120,0c47,94,178,113,251,33C2446.709,1093.793,2554.709,922.793,2379.709,863.793Z"
    transform="translate(142.69 -634.312)" fill="#eee" />
</svg>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->



<router-outlet></router-outlet>


<ng-template #ddNestedTemplate let-items="items" let-config="config" let-fns="fns">
  <div class="items-list" *ngIf="items.length" style="max-height: 250px; overflow-y: auto;padding-top: 8px;">
    <div class="items-list__item" *ngFor="let item of items">
      <div tiKeyboardActiveClass="items-list__item__parent--selected" [isKeyboardActiveItem]="item.tiKeyboardActive"
        class="items-list__item__parent" (click)="fns.onItemClicked(item)" cdkOverlayOrigin #onHoverTrigger="cdkOverlayOrigin"
        (mouseenter)="fns.showTooltip(item[config.hoverProperty], onHoverTrigger)"
        (mouseleave)="fns.hideTooltip()">
        <div class="items-list__item__parent__text">
          {{item[config.displayProperty]}}
        </div>
        <div *ngIf="item.tiSelected && config.showTagsSelectedInDD">
          <img src="../assets/tick.png" alt="tick" width="14">
        </div>
      </div>
      <ng-container
      *ngTemplateOutlet="ddNestedChildrenTemplate; context: {items: item[config.nestedTagProperty], config: config, fns: fns}">
    </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #ddNestedChildrenTemplate let-items="items" let-fns="fns" let-config="config">
  <div class="items-children-list__item__children">
    <ng-container *ngFor="let item of items">
      <div tiKeyboardActiveClass="items-children-list__item__children__child--selected"
        [isKeyboardActiveItem]="item.tiKeyboardActive" class="items-children-list__item__children__child"
        (click)="fns.onItemClicked(item, $event)">
        <div cdkOverlayOrigin #onHoverTrigger="cdkOverlayOrigin" class="items-children-list__item__children__child__item">
        <div class="items-children-list__item__children__child__item__text">
            {{item[config.displayProperty]}}
          </div>
          <div *ngIf="item.tiSelected && config.showTagsSelectedInDD">
            <img src="../assets/tick.png" alt="tick" width="14">
          </div>
        </div>
        <ng-container
          *ngTemplateOutlet="ddNestedChildrenTemplate; context: {items: item[config.nestedTagProperty], config: config, fns: fns}">
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>
